function normalizeRoles(rawRoles) {
  return rawRoles.map((role) => String(role).toLowerCase());
}

export function getStoredRoles() {
  try {
    const parsedRoles = JSON.parse(localStorage.getItem("userRoles") || "[]");
    if (Array.isArray(parsedRoles) && parsedRoles.length > 0) {
      return normalizeRoles(parsedRoles);
    }
  } catch (_error) {
    // Fallback handled below
  }

  const fallbackRole = String(localStorage.getItem("userRole") || "").toLowerCase();
  return fallbackRole ? [fallbackRole] : [];
}

export function hasRole(role) {
  const normalizedRole = String(role || "").toLowerCase();
  return getStoredRoles().includes(normalizedRole);
}

export function canCreateProfessionalUsers() {
  const roles = getStoredRoles();
  return roles.includes("admin") || roles.includes("superadmin");
}

export function isClinicManagerRole() {
  return hasRole("clinic_manager");
}
